import type { KcContext } from 'keycloakify/src/login/KcContext';
import type { IFormFieldProps } from '@bankiru/ui-kit/core/FormField/FormField.types';

export const getInputStatus = (
	messagesPerField: KcContext['messagesPerField'],
	field: string,
	extraError?: string,
): IFormFieldProps['status'] | undefined => {
	if (messagesPerField.existsError(field) || extraError) {
		return {
			type: 'error',
			message: extraError || messagesPerField.getFirstError(field),
		} as const;
	}

	return undefined;
};
